import { render } from "./form-mobile.vue?vue&type=template&id=3d65ab80&scoped=true&ts=true"
import script from "./form-mobile.vue?vue&type=script&lang=ts"
export * from "./form-mobile.vue?vue&type=script&lang=ts"

import "./form-mobile.vue?vue&type=style&index=0&id=3d65ab80&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d65ab80"]])

export default __exports__